module.exports = __webpack_public_path__ + "img/60m1.b3f810e4.jpg";